import alexPic from "@/public/images/artists/alex.png";
import { Artist } from "@/types/types";

export const alex = {
  id: "123",
  name: "Alex",
  image: alexPic,
  description: `Alex's vocal timbre is notably warm and resonant, with a distinctive raspiness that adds character to his delivery. Smooth vocal transitions, well-suited to ballads, folk, and pop tracks, further enrich the versatility of his voice. `,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Falex-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Folk", "RnB", "Dance", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
